"use strict";

/**
 * **Used for Android only:** The level of local authentication required to access the credentials. Defaults to LocalAuthenticationLevel.strong.
 */
var LocalAuthenticationLevel = /*#__PURE__*/function (LocalAuthenticationLevel) {
  /**
   * Any biometric (e.g. fingerprint, iris, or face) on the device that meets or exceeds the requirements for Class 3 (formerly Strong), as defined by the Android CDD.
   */
  LocalAuthenticationLevel[LocalAuthenticationLevel["strong"] = 0] = "strong";
  /**
   * Any biometric (e.g. fingerprint, iris, or face) on the device that meets or exceeds the requirements for Class 2 (formerly Weak), as defined by the Android CDD.
   */
  LocalAuthenticationLevel[LocalAuthenticationLevel["weak"] = 1] = "weak";
  /**
   * The non-biometric credential used to secure the device (i. e. PIN, pattern, or password).
   */
  LocalAuthenticationLevel[LocalAuthenticationLevel["deviceCredential"] = 2] = "deviceCredential";
  return LocalAuthenticationLevel;
}(LocalAuthenticationLevel || {});
export default LocalAuthenticationLevel;
//# sourceMappingURL=localAuthenticationLevel.js.map